'use strict';
module.exports = {
	amazonPayClientId: 'amzn1.application-oa2-client.b5e61810118645af9925e8f76b800071',
	amazonPayMerchantId: 'A29SKUHC053RQF',
	amazonPayScriptURL: 'https://static-eu.payments-amazon.com/OffAmazonPayments/gbp/sandbox/lpa/js/Widgets.js',
	ciscoWebexScriptURL: 'https://binaries.webex.com/static-content-pipeline/webex-embedded-app/v1/webex-embedded-app-sdk.js',
	atlasUrl: 'https://mindmup-atlas-stg.s3.amazonaws.com/',
	googleAppId: '1062229225102',
	googleOauthClientId: '1062229225102-qug6pl3ed93r6blutu3oeh41dshko1ri.apps.googleusercontent.com',
	goldAWSApiUrl: 'https://gold-api.mindmup.com/v4staging',
	imageApiUrl: 'https://d8zkpf1wab.execute-api.us-east-1.amazonaws.com/staging',
	goldBucketName: 'mindmup-gold-stg',
	websocketUrl: 'wss://x6zzv5w89e.execute-api.us-east-1.amazonaws.com/api',
	appName: {
		common: 'MindMup 2.0 (AWS Staging)',
		drive: 'MindMup Drive Staging',
		aws: 'MindMup 2.0 (Staging)'
	}
};
